// Google Analytics utility for GA4
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Inject GA4 script dynamically using the Measurement ID
function loadGAScript(id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById('ga4-script')) {
      return resolve();
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    script.id = 'ga4-script';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export const initGA = async () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('[GA] REACT_APP_GA_MEASUREMENT_ID is not set');
    return;
  }

  try {
    await loadGAScript(GA_MEASUREMENT_ID);
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line no-inner-declarations
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
    });
    console.log('[GA] Initialized with Measurement ID:', GA_MEASUREMENT_ID);
  } catch (e) {
    console.error('[GA] Failed to load GA script', e);
  }
};

export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID) return;
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, { page_path: path });
    console.log('[GA] Tracked page view:', path);
  }
};
